export default __webpack_public_path__ + "static/media/Finances.0cc215a7.svg";